import clsx from 'clsx';
import { ReactElement } from 'react';

import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import style from './Tag.module.css';

export interface TagProps {
  children: ReactElement | string;
}
export const Tag = ({ children }: TagProps) => {
  return (
    <div className={clsx(style.root, globalStyle.textNormal, globalStyle.textBold)}>
      <span className={clsx(globalStyle.textColorPrimary)}>{children}</span>
    </div>
  );
};
